export var META_ADD = 'META_ADD';
export var META_REDUCER_NAME = 'meta';